import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { ClassRecordsState } from '@/store/lessons/classRecord/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'

const Lessons: Module<ClassRecordsState, RootState> = {
  state: {
    classRecords: [],
  },
  mutations,
  actions,
  getters,
};

export default Lessons;
